import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { RadioStyled } from "./styled";
import { useTranslation } from "react-i18next";

const Radio = ({
  theme_standard,
  theme_horizontal,
  theme_question,
  theme_bosendorfer,
  theme_purple,
  label,
  errors,
  disabled,
  disabledType,
  options,
  name,
  onChange,
  value,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_horizontal: theme_horizontal,
    theme_question: theme_question,
    theme_bosendorfer: theme_bosendorfer,
    theme_purple: theme_purple,
  });

  const { t } = useTranslation(["common"]);

  const handleSelect = (optionValue) => {
    if (disabled) return;
    onChange && onChange({ target: { name, value: optionValue } });
  };

  return (
    <RadioStyled>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <div className="radio_row">
          {disabled && disabledType === "no_choice" ? (
            <div className="radio_item checked">
              <span className="custom_radio" />
              <span className="custom_label">{value}</span>
            </div>
          ) : (
            options &&
            options.map((e, i) => (
              <div
                key={i}
                className={`radio_item ${e.value === value ? "checked" : ""}`}
                onClick={() => handleSelect(e.value)}
              >
                <span className="custom_radio" />
                <span className="custom_label">{e.label}</span>
              </div>
            ))
          )}
        </div>
        {errors && <div className="errors">{t(errors, { ns: "common" })}</div>}
      </div>
    </RadioStyled>
  );
};

Radio.propTypes = {};

export default Radio;
